export default "__VITE_ASSET__DNl5f20l__"